import { render } from "./UpdateFeaturingForm.vue?vue&type=template&id=64e021ca"
import script from "./UpdateFeaturingForm.vue?vue&type=script&lang=js"
export * from "./UpdateFeaturingForm.vue?vue&type=script&lang=js"

import "./UpdateFeaturingForm.vue?vue&type=style&index=0&id=64e021ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__